export default __webpack_public_path__ + "static/media/main-bottomimg5.a5d30f1e.png";